import { render } from "./TimeoutComponent.vue?vue&type=template&id=b80150d4"
import script from "./TimeoutComponent.vue?vue&type=script&lang=js"
export * from "./TimeoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sweaton/WebstormProjects/paygateway/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__